<template>
  <div class="post">
    <van-nav-bar :title="topTitle" :rightText="lang.topclear" :left-arrow="!$route.query.fromapp" @click-left="prev()" @click-right="clear()" />
    <!-- 标题 -->
    <div class="tit">
      <span class="num">5</span>
      <span class="titname">{{ lang.propertyInfo }}</span>
    </div>
    <!-- form -->
    <van-cell-group class="background">
      <!-- 当为代理盘时显示 物业编号-->
      <div class="cell" v-if="propertyInfo.propertySource == 2">
        <div class="label">
          <p class="van-cell--required">{{ lang.propertyNumber }}</p>
          <span>{{ lang.eaaRequired }}</span>
        </div>
        <input type="text" maxlength="20" v-model="PropertyInfo.propertyNo" required @input="PropertyInfo.propertyNo = PropertyInfo.propertyNo.replace(/[\u4E00-\u9FA5]/g, '').replace(/\s*/g, '')" />
      </div>
      <!-- 放盘标题 中文 -->
      <div class=" cell spacing bottom">
        <div class="label">
          <p class="van-cell--required">{{ lang.adsTitleChi }}</p>
          <span>{{ lang.titleLimitC }}</span>
        </div>
        <input type="text" maxlength="30" v-model="PropertyInfo.titleCN" @input="sensitive" />
      </div>
      <!-- 放盘标题 英文 -->
      <div class="cell bottom">
        <div class="label">
          <p>{{ lang.adsTitleEng }}</p>
          <span>{{ lang.titleLimitE }}</span>
        </div>
        <input type="text" maxlength="50" v-model="PropertyInfo.titleEN" @input="sensitive" />
      </div>
      <!-- 楼盘介绍 中文 -->
      <div class="cell bottom spacing van-cell--required">
        <div class="label">
          <p>{{ lang.propertyDescriptionChi }}</p>
          <span>{{ lang.descriptionLimitC }}</span>
        </div>
      </div>
      <van-field v-model="PropertyInfo.introduceCN" maxlength="300" type="textarea" rows="1" :autosize="autosize" @input="sensitive" />
      <!-- 楼盘介绍 英文 -->
      <div class="cell bottom spacing">
        <div class="label">
          <p>{{ lang.propertyDescriptionEng }}</p>
          <span>{{ lang.descriptionLimitE }}</span>
        </div>
      </div>
      <van-field v-model="PropertyInfo.introduceEN" maxlength="600" type="textarea" rows="1" :autosize="autosize" @input="sensitive" />
      <!-- 單位樓層 -->
      <van-cell :title="lang.height" is-link :value="unitFloorText" class="spacing" @click="floorShow = true" />
      <van-popup v-model="floorShow" class="choose" position="top" :overlay="false">
        <van-nav-bar :title="lang.height" left-arrow @click-left="floorShow = false" :right-text="lang.confirm" @click-right="floorShow = false" />
        <van-radio-group v-model="PropertyInfo.unitFloor">
          <van-cell :title="item.dictionaryNameWithCulture" clickable @click="selectFloor(item)" v-for="(item, index) in DUnitFloor" :key="index">
            <svg class="icon iselected" aria-hidden="true" v-if="item.dictionaryValue != PropertyInfo.unitFloor">
              <use xlink:href="#icon-xuanzhong-norx"></use>
            </svg>
            <svg class="icon iselected" aria-hidden="true" v-if="item.dictionaryValue == PropertyInfo.unitFloor">
              <use xlink:href="#icon-gouxuanx"></use>
            </svg>
          </van-cell>
        </van-radio-group>
      </van-popup>
      <!--房間數目-->
      <van-cell :title="lang.noOfRooms" is-link :value="roomNumberText" @click="roomNumShow = true" />
      <van-popup v-model="roomNumShow" class="choose" position="top" :overlay="false">
        <van-nav-bar :title="lang.bedrooms" left-arrow @click-left="roomNumShow = false" :right-text="lang.confirm" @click-right="roomNumShow = false" />
        <van-radio-group v-model="PropertyInfo.roomNumber">
          <van-cell :title="item.dictionaryNameWithCulture" clickable @click="selectRoom(item)" v-for="(item, index) in DRoomNumber" :key="index">
            <!-- <van-radio :name="item.dictionaryValue" checked-color="#ED1818" @click.stop="selectRoom(item)" /> -->
            <svg class="icon iselected" aria-hidden="true" v-if="item.dictionaryValue != PropertyInfo.roomNumber">
              <use xlink:href="#icon-xuanzhong-norx"></use>
            </svg>
            <svg class="icon iselected" aria-hidden="true" v-if="item.dictionaryValue == PropertyInfo.roomNumber">
              <use xlink:href="#icon-gouxuanx"></use>
            </svg>
          </van-cell>
        </van-radio-group>
      </van-popup>
      <!-- 屋苑楼龄 -->
      <van-field v-model="PropertyInfo.buildingAge" :label="`${lang.age}`" input-align="right" type="tel" />
      <!-- 每月管理费 -->
      <van-field v-model="PropertyInfo.propertyManagementFee" :label="lang.monthlyManagementFee" input-align="right" type="tel" />
    </van-cell-group>
    <div class="next">
      <van-button class="nextBtn" @click="prev">{{ lang.prev }}</van-button>
      <van-button class="nextBtn" @click="next" :class="{ opc: VerifyNext }">{{ lang.next }}</van-button>
    </div>
    <!-- dialog提示 -->
    <van-dialog v-model="dialogShow" :confirm-button-text="lang.keyCon">
      <p class="keyWord">{{ lang.keyWords }}</p>
      <!-- <p class="mb15" v-if="document.url.indexOf('en-us') > -1">{{ lang.keyWords2 }}</p> -->
      <p></p>
      <p>{{ lang.cant }}</p>
    </van-dialog>
  </div>
</template>
<script>
import { Dialog } from "vant";
import 'vant/lib/icon/local.css';
import { mapState, mapMutations } from 'vuex'
import lang from './../../../common/language/post'
import post from "./../../../common/js/post"

export default {
  name: "step5",
  data () {
    return {
      url: document.URL,
      dialogShow: false,
      hasKeys: false,
      timer: null,
      cacheNum: "",
      cacheNum1: "",
      lang,
      post,
      topTitle: "",
      autosize: { maxHeight: 100, minHeight: 80 },
      DUnitFloor: [],
      DRoomNumber: [],
      houseAge: "",
      manMoney: "",
      floorShow: false,
      roomNumShow: false,
      roomRes: "",
      unitFloorText: "",
      roomNumberText: "",
      PropertyInfo: {
        propertyNo: "", //物业编号
        titleCN: "", // 放盤標題(中文)
        titleEN: "", //放盤標題(英文)
        introduceCN: "", //單位介紹(中文)
        introduceEN: "", //單位介紹(英文)
        unitFloor: "", // 單位樓層 int32
        roomNumber: "", // 房間數目 int32
        buildingAge: "", //屋苑樓齡(年)
        propertyManagementFee: "" //每月管理費
      }
    };
  },
  async created () {
    this.topTitle = post.getTitle(this, this.lang)
    this.getDictionary();
    if (this.propertyInfo) this.getState();
    post.getQuery(this)

  },
  watch: {
    "PropertyInfo.unitFloor" (data) {
      if (data && data > 0) {
        this.unitFloorText = post.getDictionaryText(this.PropertyInfo.unitFloor, this.DUnitFloor);      }
    },
    "PropertyInfo.roomNumber" (data) {
      if (data && data > 0) { this.roomNumberText = post.getDictionaryText(this.PropertyInfo.roomNumber, this.DRoomNumber); }
    }
  },
  computed: {
    ...mapState(["propertyInfo", "sign", "dictionary", 'showBtn']),
    VerifyNext () {
      /**这个方法只是显示按钮 为禁用色*/
      /** 验证标题是否含有敏感词*/
      if (this.hasKeys) {
        return true
      } else {
        return false
      }
      /** 如果是代理盘 需要验证下物业编号*/
      if (this.propertyInfo.propertySource == 2) {
        if (this.PropertyInfo.titleCN && this.PropertyInfo.introduceCN && this.PropertyInfo.propertyNo && !/.*[\u4e00-\u9fa5]+.*$/.test(this.PropertyInfo.propertyNo)) {
          return false
        } else {
          return true
        }
      } else {
        if (this.PropertyInfo.titleCN && this.PropertyInfo.introduceCN) {
          return false
        } else {
          return true
        }
      }

    }
  },
  methods: {
    ...mapMutations(["setProperty", "stepChange", "setSign", "clearStep5"]),
    checkInt (field) {
      /^$|^\d+$/.test(this.PropertyInfo[field])
        ? (this.cacheNum1 = this.PropertyInfo[field])
        : (this.PropertyInfo[field] = this.cacheNum1);
    },
    selectFloor (item) {
      if (this.PropertyInfo.unitFloor == item.dictionaryValue) {
        this.PropertyInfo.unitFloor = "";
        this.unitFloorText = "";
      } else {
        this.PropertyInfo.unitFloor = item.dictionaryValue;
      }
    },
    selectRoom (item) {
      if (this.PropertyInfo.roomNumber == item.dictionaryValue) {
        this.PropertyInfo.roomNumber = "";
        this.roomNumberText = "";
      } else {
        this.PropertyInfo.roomNumber = item.dictionaryValue;
      }
    },
    getState () {
      for (let k in this.propertyInfo) {
        if (this.PropertyInfo.hasOwnProperty(k)) {
          this.PropertyInfo[k] = this.propertyInfo[k]
        }
      }
    },
    getDictionary () {
      for (let key in this.dictionary) {
        if (key == "UnitFloor") {
          this.DUnitFloor = this.dictionary[key].children;
        }
        if (key == "RoomNumber") {
          this.DRoomNumber = this.dictionary[key].children;
        }
      }
    },
    prev () {
      this.setProperty(this.PropertyInfo);
      this.stepChange(4);
      this.$router.push('/post/step4/' + this.query)
    },
    async next () {
      if (this.validate_required()) {
        let res = await this.sensitive('history')
        if (res.data.code == 0) {
          this.hasKeys = res.data.result;
          if (this.hasKeys) {
            return this.dialogShow = true
          }
        }
        this.setProperty(this.PropertyInfo);
        this.stepChange(6);
        this.$router.push('/post/step6/' + this.query)
      }
    },
    /*获取敏感词判断标题介绍中是否含有  HOUSEMIS-552*/
    /*判断标题是否含有敏感词--防抖 避免多次触发*/
    sensitive (type) {
      if (this.timer) {
        clearInterval(this.timer);
      }
      let keywords = [this.PropertyInfo.titleCN, this.PropertyInfo.titleEN, this.PropertyInfo.introduceCN, this.PropertyInfo.introduceEN]
      if (type == 'history') {
        return this.axios.post(this.pub.getApi().GetKeyword, { keywords });
      }
      this.timer = setTimeout(() => {
        this.timer = null;
        this.hasKeys = true;
        this.axios.post(this.pub.getApi().GetKeyword, { keywords }).then(res => {
          if (res.data.code == 0) {
            if (res.data.result) {
              this.hasKeys = true;//有敏感词
              this.dialogShow = true
            } else {
              this.hasKeys = false;//无敏感词
            }
          }
        });
      }, 500);
    },

    clear () {
      Dialog.confirm({
        title: lang.Clearcontent,
        cancelButtonText: lang.cancel,
        confirmButtonText: lang.confirm
      })
        .then(() => {
          //  1.清空 vuex 中的数据
          this.clearStep5();
          //  2. 清空本页面的v-model 的数据
          this.PropertyInfo.propertyNo = "";
          this.PropertyInfo.titleCN = "";
          this.PropertyInfo.titleEN = "";
          this.PropertyInfo.introduceCN = "";
          this.PropertyInfo.introduceEN = "";
          this.PropertyInfo.unitFloor = "";
          this.PropertyInfo.roomNumber = "";
          this.PropertyInfo.buildingAge = "";
          this.PropertyInfo.propertyManagementFee = "";
          this.unitFloorText = "";
          this.roomNumberText = "";
        })
        .catch(() => { });
    },
    validate_required () {
      if (this.PropertyInfo.propertyNo) {
        this.PropertyInfo.propertyNo = this.PropertyInfo.propertyNo.replace(/\s*/g, '')
      }
      if (this.propertyInfo.propertySource == 2) {
        if (this.PropertyInfo.propertyNo === null || !this.PropertyInfo.propertyNo.trim()) {
          this.$notify(lang.require5.adspropertyNumber);
          return;
        }
        if (/.*[\u4e00-\u9fa5]+.*$/.test(this.PropertyInfo.propertyNo)) {
          this.$notify(lang.require5.adspropertyNumErr);
          return;
        }
      }
      if (!this.PropertyInfo.titleCN.trim()) {
        this.$notify(lang.require5.adsTitleChi);
        return;
      }
      if (!this.PropertyInfo.introduceCN.trim().length) {
        this.$notify(lang.require5.propertyDescriptionChi);
        return;
      }
      if (this.PropertyInfo.buildingAge && !/^\d{0,5}$/.test(this.PropertyInfo.buildingAge)) {
        this.$notify(lang.require5.age);
        return;
      }
      if (this.PropertyInfo.propertyManagementFee && !/^\d{0,6}$/.test(this.PropertyInfo.propertyManagementFee)) {
        this.$notify(lang.require5.monthlyManagementFee);
        return;
      }
      if (this.hasKeys) {
        this.dialogShow = true;
        return;
      }
      return true;
    }
  },

  beforeDestroy () {
    this.setProperty({ ...this.PropertyInfo });
  },
  components: {
    [Dialog.name]: Dialog
  }
};
</script>

<style lang="scss" scoped>
.keyWord {
  line-height: 25px;
}
.mb15 {
  margin-bottom: 20px;
  line-height: 18px;
}
/deep/.van-dialog__content {
  padding: 25px;
  text-align: center;
}
.opc {
  opacity: 0.5;
}
.iselected {
  font-size: 22px;
}
.van-nav-bar {
  border-bottom: 1px solid #e3e4e6;
  background-color: #fafbfc;
}
.van-nav-bar__title {
  font-size: 17px;
  font-weight: 600;
}
.van-nav-bar__text {
  color: #333;
}
.van-nav-bar .van-icon {
  font-size: 25px;
  color: black;
}
/deep/ .van-field__label {
  max-width: 180px;
}
.post {
  padding-bottom: 64px;
  box-sizing: border-box;
}
.background {
  background-color: #f6f7f8;
}
.choose {
  width: 100%;
  height: 100%;
  background-color: #f6f7f8;
}
.spacing {
  margin-top: 15px;
}
.bottom {
  border-bottom: 1px solid #eee;
}
.cell {
  background-color: #fff;
  font-size: 15px;
  display: flex;
  justify-content: space-between;
  padding: 8px 15px;
  p {
    color: #333;
  }
  span {
    font-size: 10px;
    color: #b2b2b2;
  }
  input {
    width: 40%;
    border: none;
    text-align: right;
  }
  input::-webkit-input-placeholder {
    font-size: 15px;
    color: #999999;
  }
}
</style>
